import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "overview"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#example2" }),
  /*#__PURE__*/_createTextVNode(" Multiselect with object options ")
], -1)
const _hoisted_3 = { class: "py-5" }
const _hoisted_4 = { class: "bg-dark text-white rounded-1 mb-2 p-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_CodeHighlighter2 = _resolveComponent("CodeHighlighter2")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, " Data: " + _toDisplayString(_ctx.example2.value), 1),
      _createVNode(_component_Multiselect, _mergeProps({
        modelValue: _ctx.example2.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.example2.value = $event))
      }, _ctx.example2), null, 16, ["modelValue"]),
      _createVNode(_component_CodeHighlighter2, null, {
        html: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.htmlCode), 1)
        ]),
        js: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.jsCode), 1)
        ]),
        _: 1
      })
    ])
  ]))
}